import { MainInner } from "@/styles/global";
import { Paragraph, h2 } from "@/styles/typography";
import styled from "styled-components";

const Inner = styled(MainInner)<{ $mediaPosition: string; $bgColor: string }>`
  flex-direction: column;
  gap: 24px;
  align-items: center;
  justify-content: center;
  background-color: ${({ $bgColor }) => $bgColor};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    gap: 74px;

    flex-direction: ${({ $mediaPosition }) =>
      $mediaPosition === "left" ? "row" : "row-reverse"};
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: 50%;
  }
`;

const Title = styled(h2)``;

const Text = styled(Paragraph)``;

const BtnWrapper = styled.div`
  margin-top: 16px;
`;

const VimeoHero = styled.div`
  width: 100%;
  aspect-ratio: 16/9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;

  iframe {
    border-radius: 4px;
    width: 100%;
    height: 100%;
    aspect-ratio: 16/9;
    border: none;
    background: ${({ theme }) => theme.colors.coreDark};

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
      min-width: 50%;
    }
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    max-width: 50%;
    height: 100%;
  }
`;

const VideoWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const IconWrapper = styled.div<{ $mediaPosition: string }>`
  transform: scale(-1, 1);
  top: 20px;
  position: absolute;
  right: 0px;

  svg {
    width: 60%;
    height: 60%;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    right: 10px;
    top: 15px;

    svg {
      width: 80%;
      height: 80%;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    top: 20px;

    svg {
      width: 59px;
      height: 52px;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    top: 8%;

    ${({ $mediaPosition }) =>
      $mediaPosition === "left"
        ? `
      transform: scale(1,1);
      left: 16px;
      `
        : `
      right: 16px;
    `};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xxl}) {
    top: 10%;

    ${({ $mediaPosition }) =>
      $mediaPosition === "left"
        ? `
      transform: scale(1,1);
      left: 80px;
      `
        : `
      right: 80px;
    `};
  }
`;

const S = {
  Inner,
  ContentWrapper,
  Title,
  Text,
  BtnWrapper,
  VimeoHero,
  VideoWrapper,
  IconWrapper,
};

export default S;
